export const creator_AFB959L7 = {
    theme: {
        is_telegram_white_theme: true,
    },
    faqs: [
        {
            q: 'Link for our free telegram community',
            a: () => (
                <p>
                    Join us here: {" "}
                    <a className="underline" href="https://t.me/nkumarchali" target="_blank">
                        nkumarchali
                    </a>
                </p>
            )
        }
    ]
};